import { createTheme, ThemeOptions } from "@mui/material/styles"
import { sharedTheme } from "ui"
import sharedColors from "./colors"

const customTheme = createTheme({
  ...sharedTheme,
} as ThemeOptions)

export const theme = {
  ...customTheme,
  sharedColors,
} as const

export type Theme = typeof theme
